import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Card,
  Box,
  Pagination,
  Stack,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { ToastContainer, toast } from "react-toastify";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EmptyData from "../../components/EmptyData";
import { useSelector } from "react-redux";
import ImageModal from "components/ImageModal";
import GoogleMapModal from "../../DialogBox/googlemap";
import apiClient from "../../Utils/apiClient";
import ShieldIcon from "@mui/icons-material/Security";
import WifiIcon from "@mui/icons-material/Wifi";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import WarningIcon from "@mui/icons-material/Warning";
import VehicleTrackingAction from "Utils/VehicleTrackingAction";
import NotificationLog from "components/Notificationlog";
import AlertCard from "components/AlertCard";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const GpsVehicleTracking = () => {
  const getUserState = useSelector((state) => state?.data?.getUserState);
  const [allData, setAllData] = useState([]);
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);
  const navigate = useNavigate();

  const [statusFilter, setStatusFilter] = useState("");
  const [movementFilter, setMovementFilter] = useState(""); 

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onClickImageData, setOnClickImageData] = useState("");
  const [openMap, setOpenMap] = useState(false);
  const [mapMarkers, setMapMarkers] = useState([]);
  const [userPath, setUserPath] = useState([]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedMovement, setSelectedMovement] = useState("All");
  const [selectedStolen, setSelectedStolen] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [alerts, setAlerts] = useState([]);

  const getAlerts = async () => {
    try {
      const res = await apiClient.get("/notifications");
      setAlerts(res.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAlerts();
  }, []);

  const alarmConfig = {
    REMOVE: { type: "power", title: "Device Disassembled" },
    REMOVECONTINUOUSLY: { type: "power", title: "Continuous Power Failure" },
    SOS: { type: "power", title: "SOS Emergency" },
    SHAKE: { type: "power", title: "Vibration Alarm" },
    CRASH: { type: "power", title: "Collision Detected" },
    TURNOVER: { type: "power", title: "Vehicle Flip/Turnover" },
    ACCON: { type: "power", title: "Engine Started" },
    ACCOFF: { type: "power", title: "Engine Stalled" },
    SEP: { type: "power", title: "Separation Alarm" },
    VINMISMATCH: { type: "power", title: "VIN Mismatch" },
    OFFLINETIMEOUT: { type: "power", title: "Device Offline" },

    LOWVOT: { type: "battery", title: "Low Battery Alarm" },
    ERYA: { type: "battery", title: "Secondary Battery Alert" },

    FENCEIN: { type: "geo", title: "Entered Fence" },
    FENCEOUT: { type: "geo", title: "Exited Fence" },
    AREAIN: { type: "geo", title: "Entered Zone" },
    AREAOUT: { type: "geo", title: "Exited Zone" },
    OVERSPEED: { type: "geo", title: "Overspeeding" },
    STAYTIMEOUT: { type: "geo", title: "Parking Timeout" },
    HOME: { type: "geo", title: "Not Home Alert" },
    COMPANY: { type: "geo", title: "Work Absence Alert" },
    RISKPLACE: { type: "geo", title: "Risk Point Stay" },
    ABNORMALACCUMULATION: { type: "geo", title: "Abnormal Aggregation" },
    AUTO_PARK_SUGGESTION: { type: "geo", title: "Parking Suggestion" },
    Vehicle_AUTO_: { type: "geo", title: "Auto Parked" },
    FASTACCELERATION: { type: "geo", title: "Rapid Acceleration" },
    FASTDECELERATION: { type: "geo", title: "Rapid Deceleration" },
    SHARPTURN: { type: "geo", title: "Sharp Turn Detected" },
  };
  useEffect(() => {
    getData(page, limit);
  }, [getUserState, page, limit, selectedStatus, selectedMovement, selectedStolen]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      getData(1, limit);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const getData = async (page, limit) => {
    try {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      setCheckSuperAdmin(currentUser?.superAdmin);
      setAdminState(currentUser?.state);

      const response = await apiClient.get("/vehicles", {
        params: {
          page,
          limit,
          status: selectedStatus !== "All" ? selectedStatus.toLowerCase() : "",
          movementStatus: selectedMovement !== "All" ? selectedMovement.toLowerCase() : "",
          stolen: selectedStolen !== "All" ? selectedStolen : "",
          search: searchText || "",
        },
      });

      setAllData(response?.data || []);
      setTotalPages(response?.pagination?.totalPages || 1);
    } catch (error) {
      toast.error(error.message || "Failed to fetch vehicles");
      setAllData([]);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const onClose = () => {
    setIsModalOpen(false);
  };

  return (
    <DashboardLayout>
      <MDBox pt={9} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={2} mb={2}>
              {[
                {
                  title: "Total Protected Vehicles",
                  value: "0",
                  icon: <ShieldIcon sx={{ fontSize: 40 }} />,
                  bg: "#7dbdeaca",
                  color: "#1976d2",
                },
                {
                  title: "Vehicles Online",
                  value: "1",
                  icon: <WifiIcon sx={{ fontSize: 40 }} />,
                  bg: "#97e89e",
                  color: "#2e7d32",
                },
                {
                  title: "Vehicles Offline",
                  value: "0",
                  icon: <DirectionsCarIcon sx={{ fontSize: 40 }} />,
                  bg: "#f3a4a4",
                  color: "#b13535",
                },
                {
                  title: "Moving Vehicles",
                  value: "0",
                  icon: <DirectionsCarIcon sx={{ fontSize: 40 }} />,
                  bg: "#f1cb8d",
                  color: "#ef6c00",
                },
                {
                  title: "Parked Vehicles",
                  value: "1",
                  icon: <DirectionsCarIcon sx={{ fontSize: 40 }} />,
                  bg: "#8ec4eb",
                  color: "#1565c0",
                },
                {
                  title: "Active Alerts",
                  value: "0",
                  icon: <WarningIcon sx={{ fontSize: 40 }} />,
                  bg: "#ed8bce",
                  color: "#f925f5",
                },
              ].map((item, index) => (
                <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
                  <Card
                    sx={{
                      borderRadius: "12px",
                      background: item.bg,
                      color: item.color,
                      p: 2,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box
                        sx={{
                          width: 50,
                          height: 50,
                          borderRadius: "12px",
                          backgroundColor: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {React.cloneElement(item.icon, { sx: { fontSize: 28, color: item.color } })}
                      </Box>

                      <Box>
                        <MDTypography
                          variant="h5"
                          sx={{ fontWeight: "bold", color: "#ffffff", lineHeight: 1 }}
                        >
                          {item.value}
                        </MDTypography>

                        <MDTypography
                          variant="body2"
                          sx={{ color: "#ffffff", fontSize: "12px", fontWeight: "bold" }}
                        >
                          {item.title}
                        </MDTypography>
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
            <Card>
              <MDBox
                display="flex"
                gap={2}
                p={2}
                mb={4}
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" gap={1}>
                  <TextField
                    placeholder="Search by phone number, license plate, or owner name"
                    variant="outlined"
                    size="small"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    sx={{
                      width: 300,
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                    }}
                  />
                </Box>

                <Box display="flex" gap={2}>
                  <TextField
                    label="Status"
                    select
                    size="small"
                    value={selectedStatus}
                    onChange={(e) => {
                      setSelectedStatus(e.target.value);
                      setPage(1);
                    }}
                    sx={{ width: 150 }}
                    SelectProps={{ native: true }}
                  >
                    <option value="All">All</option>
                    <option value="online">Online</option>
                    <option value="offline">Offline</option>
                  </TextField>

                  <TextField
                    label="Movement Status"
                    select
                    size="small"
                    value={selectedMovement}
                    onChange={(e) => {
                      setSelectedMovement(e.target.value);
                      setPage(1);
                    }}
                    sx={{ width: 180 }}
                    SelectProps={{ native: true }}
                  >
                    <option value="All">All</option>
                    <option value="moving">Moving</option>
                    <option value="parked">Parked</option>
                  </TextField>

                  <TextField
                    label="Stolen"
                    select
                    size="small"
                    value={selectedStolen}
                    onChange={(e) => {
                      setSelectedStolen(e.target.value);
                      setPage(1);
                    }}
                    sx={{ width: 150 }}
                    SelectProps={{ native: true }}
                  >
                    <option value="All">All</option>
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </TextField>
                </Box>
              </MDBox>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} p={1}>
                <Typography variant="h6" fontWeight={600}>
                  Recent Alerts
                </Typography>

                <Button
                  size="small"
                  onClick={() => navigate("/Notificationlog")}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                  }}
                >
                  View All Alerts <ArrowForwardIcon />
                </Button>
              </Box>
              <Grid container spacing={2} mb={4}>
                {alerts.length === 0 ? <EmptyData /> :
                  alerts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    .slice(0, 3).map((alert, index) => {

                      const config = alarmConfig[alert.alertType] || {
                        type: "geo",
                        title: alert.alertType ? alert.alertType.replace(/_/g, ' ') : "Unknown Alert",
                      };

                      return (
                        <Grid item xs={12} md={4} key={index}>
                          <AlertCard
                            type={config.type}
                            title={config.title}
                            vehicle={`${alert.vehicleName || "Vehicle"} • ${alert.licensePlate || alert.imei}`}
                            time={alert.createdAt ? new Date(alert.createdAt).toLocaleString() : "N/A"}
                            status={alert.status}
                            alertStatus={alert.alertStatus}
                            buttonText={
                              alert.alertStatus === "Pending" ? "Take Action" : "View Details"
                            }
                            onClick={() => navigate("/Notificationlog")}
                          />
                        </Grid>
                      );
                    })}
              </Grid>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ textAlign: "center" }}
              >
                <ToastContainer />
                <MDTypography variant="h6" color="white">
                  Vehicle GPS Tracking
                </MDTypography>
              </MDBox>

              {allData.length > 0 ? (
                <MDBox>
                  <TableContainer component={Paper}>
                    <Table sx={{ "& td, & th": { fontSize: "14px", padding: "8px" } }}>
                      <TableBody>
                        <TableRow>
                          {[
                            "SR",
                            "Vehicle Images",
                            "Vehicle Name",
                            "Owner Name",
                            "License Plate No",
                            // "Engine Number",
                            "Phone",
                            "Movement Status",
                            // "Stolen",
                            "Status",
                            "Action",
                          ].map((label) => (
                            <TableCell key={label} align="center" sx={{ fontWeight: "bold" }}>
                              {label}
                            </TableCell>
                          ))}
                        </TableRow>

                        {allData.map((post, index) => (
                          <TableRow key={post?._id || index}>
                            <TableCell align="center">{(page - 1) * limit + index + 1}</TableCell>

                            <TableCell align="center">
                              <Box display="flex" gap={1} justifyContent="center" flexWrap="wrap">
                                {post.images?.slice(0, 3).map((img, idx) => (
                                  <img
                                    key={idx}
                                    src={img}
                                    alt={`vehicle-${idx}`}
                                    style={{
                                      width: 50,
                                      height: 50,
                                      objectFit: "cover",
                                      borderRadius: 4,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setOnClickImageData(img);
                                      setIsModalOpen(true);
                                    }}
                                  />
                                ))}
                              </Box>
                            </TableCell>

                            <TableCell align="center">{post?.vehicleNickname || "N/A"}</TableCell>
                            <TableCell align="center">{post?.ownerName || "N/A"}</TableCell>
                            <TableCell align="center">{post?.licensePlate || "N/A"}</TableCell>
                            {/* <TableCell align="center">{post?.engineNumber || "N/A"}</TableCell> */}
                            <TableCell align="center">{post?.phone || "N/A"}</TableCell>
                            <TableCell align="center">{post?.movementStatus || "N/A"}</TableCell>
                            {/* <TableCell align="center">
                              {post?.stolen ? "True" : "False" || "N/A"}
                            </TableCell> */}
                            <TableCell align="center">{post?.status || "N/A"}</TableCell>
                            {/* WRAPPED IN TABLECELL TO FIX FLOATING ICON */}
                            <TableCell align="center">
                              <VehicleTrackingAction props={post} />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                    />
                  </Stack>
                </MDBox>
              ) : (
                <EmptyData />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <ImageModal onClickImageData={onClickImageData} onClose={onClose} isModalOpen={isModalOpen} />
      <GoogleMapModal
        open={openMap}
        onClose={() => setOpenMap(false)}
        markerList={mapMarkers}
        userLocation={userPath}
      />
    </DashboardLayout>
  );
};

export default GpsVehicleTracking;